<template>
  <app-cell
    class="radio-cell"
    :edit="!!form"
    :deletable="!!radio"
    :loading="!!form && form.isLoading"
    @edit="onEdit"
    @save="onSave"
    @cancel="onCancel"
    @delete="onDelete"
  >
    <template slot="content" v-if="radio">
      <div class="radio-cell__content">
        <h2 class="radio-cell__title">{{ radio.title }}</h2>
        <p class="radio-cell__description">{{ radio.description }}</p>
        <div class="radio-cell__box">
          <p class="radio-cell__entry">
            <span class="entry__label">AWS S3 file path:</span>
            <a :href="radio.url" target="_blank">{{ radio.fileKey }}</a>
          </p>
        </div>
        <audio v-if="radio.url" :src="radio.url" controls class="radio-cell__audio" />
      </div>
    </template>
    <template slot="form" v-if="!!form">
      <form @submit.prevent class="radio-cell__form">
        <base-form-input class="form__input" label="Title">
          <input v-model="form.title" placeholder="Track title" />
        </base-form-input>
        <base-form-input class="form__input" label="Description">
          <input v-model="form.description" placeholder="Track subtitle" />
        </base-form-input>
        <p class="form__description">
          Upload the audio to Amazon S3 in root bucket
          <i>('avatar-country-dev' for test environment)</i>.
        </p>
        <base-form-input class="form__input" label="Name on Amazon S3">
          <input v-model="form.fileKey" placeholder="radio.mp3" />
        </base-form-input>
        <base-form-input v-if="form.sortOrder != null" class="form__input" label="Sort order">
          <input v-model.number="form.sortOrder" placeholder="Sort order" type="number" />
        </base-form-input>
      </form>
    </template>
  </app-cell>
</template>

<script lang="ts">
import AppCell from '@/components/Cell.vue';
import { CreateRadioForm, RadioForm, UpdateRadioForm } from '@/forms/radio';
import gql from 'graphql-tag';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Radio } from '../types/api';

@Component({
  components: { AppCell },
})
export default class RadioCell extends Vue {
  @Prop()
  public radio?: Radio;

  public form = null as RadioForm | null;

  public onEdit() {
    this.form = this.radio ? new UpdateRadioForm(this.radio) : new CreateRadioForm();
  }

  public onCancel() {
    this.closeForm();
  }

  public async onSave() {
    await this.form!.save();
    this.closeForm();
  }

  public async onDelete() {
    await this.$apollo.mutate({
      mutation: gql`
        mutation DeleteRadio($input: DeleteRadioInput!) {
          deleteRadio(input: $input) {
            success
          }
        }
      `,
      variables: { input: { id: this.radio!.id } },
      refetchQueries: ['Tracks'],
    });
  }

  private closeForm() {
    this.form = null;
    this.$emit('close');
  }

  public mounted() {
    if (!this.radio) {
      this.form = new CreateRadioForm();
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-cell {
  &__title {
    margin-bottom: 8px;
  }
  &__description {
    margin-bottom: 16px;
  }
  &__box {
    width: 70%;
    padding: 12px 16px;
    margin-bottom: 16px;
    border: 1px solid $color-theme-red;
  }
  &__entry {
    .entry__label {
      font-weight: bold;
      margin-right: 8px;
    }
  }
  &__audio {
    width: 100%;
    max-width: 400px;
  }
  &__form {
    flex: 1;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    .form__input {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
    .form__description {
      margin-top: 12px;
      i {
        font-style: italic;
      }
    }
  }
}
</style>
